<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: '哆哆创客少儿编程官网',
    meta: [
      {
        name: 'keywords',
        content: '哆哆创客 哆哆编程 少儿编程 Scratch C++ Python NOIP NOI 信息学奥赛 人工智能教育 JAVA 哆哆科技 创客'
      },
      {
        name: 'description',
        content: '哆哆创客，专注少儿编程、人工智能教育。主要课程为机器人编程、Scratch图形化编程、JavaScript、Python、C++，采用全美式体验教学，激发孩子学习兴趣，让孩子成为人工智能时代的领导者！'
      }
    ]
  }
}
</script>

<style>
@import url("./app.css");
</style>



// WEBPACK FOOTER //
// src/App.vue